import React from "react";
import { Modal, Button } from "react-bootstrap";

const ActionModal = ({
  show,
  handleClose,
  title,
  children,
  handleSave,
}) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{children}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
        {title === "Delete role" ? (
          <Button variant="danger" onClick={handleSave}>
            Delete
          </Button>
        ) : (
          <Button variant="primary" onClick={handleSave}>
            Save Changes
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default ActionModal;
